// extracted by mini-css-extract-plugin
export default {"root":"IntegrationHomePage__root--3jquo","breadcrumbsWrapper":"IntegrationHomePage__breadcrumbsWrapper--1t_fF"};